export default function getInitState() {
    return {
        gridIsOpen: true,
        formIsOpen: false,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            },
        },
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új vizsgálati dokumentum típus',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            },
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            }, {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        searchFields: [
            {
                name: "name",
                label: "Név",
                formVisible: true,
                formSize: 5,
                formType: 'text',
            },
        ],
        headerFields: [
            {
                name: "id",
                label: "Azonosító",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "name",
                label: "Név",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formVisible: true,
                formRequired: true,
                formSize: 5,
                formType: 'text',
            },
            {
                name: "tigPrice",
                label: "TIG ár",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formVisible: true,
                formRequired: true,
                formSize: 4,
                formType: 'number',
            },
            {
                name: "tigEnabled",
                label: "TIG-re küldhető",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formVisible: true,
                formRequired: false,
                formSize: 3,
                formType: 'checkbox',
                slot_name: "isTIGFormat"
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
    }
}
